import React from "react";
import Rectangle1 from "../assets/Rectangle1.svg";
import Rectangle2 from "../assets/Rectangle2.svg";
import Rectangle3 from "../assets/Rectangle3.svg";
import Rectangle4 from "../assets/Rectangle4.svg";

const supermarkets = [Rectangle1, Rectangle2, Rectangle3, Rectangle4];

function SupermarketTabs() {
  return (
    <div className="grid grid-cols-2 gap-3 rounded-2xl border border-slate-200 bg-white p-4 sm:grid-cols-4">
      {supermarkets.map((name) => (
        <img
        src={name}
          key={name}
          className="rounded-xl bg-slate-50  text-xs font-semibold text-slate-700 hover:border-indigo-500 hover:text-indigo-600"
       />
         
      ))}
    </div>
  );
}

export default SupermarketTabs;